export default __webpack_public_path__ + "static/media/crypto-coins.811a0373.png";